var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fd397a",
    opacity: 0.3,
    d: "M9.756,4.414,2.8,16.926a.833.833,0,0,0,.728,1.238h14.6a.833.833,0,0,0,.711-1.268L11.2,4.384a.833.833,0,0,0-1.439.03Z",
    transform: "translate(-0.45 -0.664)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fd397a",
    width: 1.667,
    height: 5.833,
    rx: 0.833,
    transform: "translate(9.167 7.5)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fd397a",
    width: 1.667,
    height: 1.667,
    rx: 0.833,
    transform: "translate(9.167 14.167)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.c5b7aa1c4ae7ea827ae9f8c63b1d9f7e.svg";
export { ForwardRef as ReactComponent };